<template>
  <div class="modal-content fm-modal-video-player">
    <div class="modal-header">
      <h5 class="modal-title w-75 text-truncate">
        {{ lang.modal.videoPlayer.title }} <small class="text-muted ps-3">{{ videoFile.basename }}</small>
      </h5>
      <button type="button" class="btn-close" aria-label="Close" v-on:click="hideModal"></button>
    </div>
    <div class="modal-body">
      <video ref="fmVideo" controls />
    </div>
  </div>
</template>

<script>
import Plyr from 'plyr';
import modal from '@/Modules/FileManager/views/components/modals/mixins/modal';
import translate from '@/Modules/FileManager/mixins/translate';

export default {
  name: 'VideoPlayerModal',
  mixins: [modal, translate],
  data() {
    return {
      player: {},
    };
  },
  mounted() {
    // initiate video player
    this.player = new Plyr(this.$refs.fmVideo);
    // load source
    this.setSource();
  },
  beforeDestroy() {
    this.player.destroy();
  },
  computed: {
    /**
     * Selected disk
     * @returns {*}
     */
    selectedDisk() {
      return this.$store.getters['fm/selectedDisk'];
    },

    /**
     * Video file
     * @returns {*}
     */
    videoFile() {
      return this.$store.getters['fm/selectedItems'][0];
    },

    authToken() {
      return Ls.get('auth.token');
    },
  },
  methods: {
    async setSource() {
      const videoUrl = `${this.$store.getters['fm/settings/baseUrl']}stream-file?disk=${this.selectedDisk}&path=${encodeURIComponent(this.videoFile.path)}`;
      const token = this.authToken;

      try {
        const videoBlobUrl = await this.loadVideoWithAuth(videoUrl, token);
        this.player.source = {
          type: 'video',
          title: this.videoFile.filename,
          sources: [
            {
              src: videoBlobUrl,
              type: `video/${this.videoFile.extension}`,
            },
          ],
        };
      } catch (error) {
        console.error("Erreur lors du chargement de la vidéo", error);
      }
    },

    async loadVideoWithAuth(url, token) {
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Erreur lors du téléchargement de la vidéo');

        const blob = await response.blob();
        return URL.createObjectURL(blob); // Retourne l'URL du fichier Blob
      } catch (error) {
        throw new Error('Erreur réseau ou autre: ' + error.message);
      }
    },
  },
};
</script>

<style lang="scss">
//@import 'plyr/src/sass/plyr.scss';
.fm-modal-video-player {
}
</style>
